var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M21.3,33.8l4.3,2.6c0.8,0.6,1.8,0.9,2.8,0.9c1.4,0,2.7-0.6,3.7-1.6l1.2-1.2l0.5,0.5h0.8l2.5-2.6 c0.1-0.1,0.2-0.2,0.2-0.3c0-0.2-0.1-0.3-0.2-0.4l-6-6c-0.2-0.1-0.5-0.1-0.7,0l-2.5,2.6c-0.2,0.2-0.2,0.5,0,0.7l0.5,0.5L27,30.9 c-0.3,0.2-0.7,0.2-1,0l-11.9-12c-0.3-0.3-0.3-0.7,0-1c0,0,0,0,0,0l1.3-1.3l0.5,0.5h0.8l2.5-2.6l0.2-0.3c0-0.2-0.1-0.3-0.2-0.4l-6-6 h-0.7L10,10.4c-0.2,0.2-0.2,0.5,0,0.7l0.5,0.5l-1.2,1.2c-1.8,1.7-2.1,4.5-0.8,6.6l2.7,4.3C13.8,27.8,17.2,31.2,21.3,33.8z  M30.8,26.8l5.2,5.3l-1.8,1.8l-0.5-0.5l-2.1-2.1l-2.7-2.6L30.8,26.8z M12.9,8.9l5.2,5.3L16.3,16l-0.5-0.5l-2.1-2.1L11,10.8 L12.9,8.9z M9.4,18.9c-1.1-1.7-0.8-4,0.6-5.4l1.2-1.2l1.7,1.8l1.8,1.8l-1.3,1.3c-0.7,0.7-0.7,1.8,0,2.5l11.9,11.9 c0.7,0.6,1.7,0.6,2.4,0l1.4-1.4l1.7,1.8l1.8,1.8L31.4,35c-1.4,1.4-3.6,1.6-5.3,0.6l-4.3-2.7c-4-2.5-7.3-5.8-9.8-9.8L9.4,18.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A1A1A1",
    points: "15.8,15.5 16.3,16 18.1,14.2 12.9,8.9 11,10.8 13.7,13.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A1A1A1",
    points: "31.6,31.3 33.7,33.4 34.2,33.9 36,32.1 30.8,26.8 28.9,28.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M21.8,32.9l4.3,2.7c1.7,1,3.9,0.8,5.3-0.6l1.2-1.2L30.8,32l-1.7-1.8l-1.4,1.4c-0.7,0.6-1.7,0.6-2.4,0 L13.4,19.7c-0.7-0.7-0.7-1.8,0-2.5l1.3-1.3l-1.8-1.8l-1.7-1.8L10,13.5c-1.4,1.4-1.7,3.7-0.6,5.4l2.6,4.2 C14.5,27.1,17.8,30.4,21.8,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.5,7.7c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c7.6,0,13.7,6.1,13.7,13.7c0,0,0,0.1,0,0.1 c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.6-0.2,0.6-0.5C37.3,14.3,30.7,7.7,22.5,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.2,22.5c0.3,0,0.5-0.2,0.5-0.5c0-5.4-4.3-9.7-9.7-9.7c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5 c4.8,0,8.7,3.9,8.7,8.7C31.7,22.3,31.9,22.5,32.2,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M28.1,21.5c0-2.5-2.1-4.6-4.6-4.6c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c2,0,3.6,1.6,3.6,3.6 c0,0.3,0.2,0.5,0.5,0.5C27.9,22,28.1,21.8,28.1,21.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.04627608f08533ab4b32b8772e24026a.svg";
export { ForwardRef as ReactComponent };